import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Intro from "@/components/Intro";
import Gastronomy from "@/components/Gastronomy";
import ExperienceCards from "@/components/ExperienceCards";
import TransitionQuote from "@/components/TransitionQuote";
import Guesthouse from "@/components/Guesthouse";
import Events from "@/components/Events";
import Animals from "@/components/Animals";
import Boards from "@/components/Boards";
import TransitionBlur from "@/components/TransitionBlur";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MobileStickyCTA from "@/components/MobileStickyCTA";
import ScrollToTop from "@/components/ScrollToTop";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/lib/cartContext";
import useScrollReveal from "@/hooks/useScrollReveal";
import FalusiVendegasztal from "@/pages/FalusiVendegasztal";
import Vendeghaz from "@/pages/Vendeghaz";
import GyerekWorkshopok from "@/pages/GyerekWorkshopok";
import Vagodeszkak from "@/pages/Vagodeszkak";
import WebshopSuccess from "@/pages/WebshopSuccess";
import Rolunk from "@/pages/Rolunk";
import Adatkezeles from "@/pages/Adatkezeles";
import Cookie from "@/pages/Cookie";

const HomePage = () => {
  useScrollReveal();

  useEffect(() => {
    document.title = "Pakkaland · A Tisza partján, a tűz melegénél";
  }, []);

  return (
    <div data-testid="home-page" className="bg-white text-pkcharcoal">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <Gastronomy />
        <ExperienceCards />
        <TransitionQuote />
        <Guesthouse />
        <Events />
        <Animals />
        <Boards />
        <TransitionBlur />
        <Gallery />
        <Contact />
      </main>
      <Footer />
      <MobileStickyCTA />
      <div className="lg:hidden h-20" aria-hidden="true" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/falusi-vendegasztal" element={<FalusiVendegasztal />} />
            <Route path="/vendeghaz" element={<Vendeghaz />} />
            <Route path="/gyerek-workshopok" element={<GyerekWorkshopok />} />
            <Route path="/vagodeszkak" element={<Vagodeszkak />} />
            <Route path="/webshop-success" element={<WebshopSuccess />} />
            <Route path="/rolunk" element={<Rolunk />} />
            <Route path="/adatkezeles" element={<Adatkezeles />} />
            <Route path="/cookie" element={<Cookie />} />
          </Routes>
          <CartDrawer />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
